export default __webpack_public_path__ + "static/media/news-placeholder-image.a435a750.svg";